function listUsers(list) {
  return list.filter(Boolean).map((o) => o.displayName).join(', ');
}

export default listUsers;
